import axios from "axios";
import { jwtDecode } from "jwt-decode";
let baseURL = "";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((configReq) => {
  if (!baseURL) {
    const config = useRuntimeConfig();
    baseURL =
      !import.meta.dev
        ? `${location.origin}`
        : config.public.apiBase;
    axiosInstance.defaults.baseURL = baseURL;
  }
  return configReq;
});

const isFormData = (obj: any): obj is FormData => {
  return obj instanceof FormData;
};

const refreshToken = async () => {
  try {
    const url =
      !import.meta.dev ? baseURL + "/api/" : baseURL;
    const authTokenStore = localStorage.getItem("token")?.includes("Bearer")
      ? localStorage.getItem("token")?.replace("Bearer ", "")
      : localStorage.getItem("token");
    const authRfToken = localStorage.getItem("rfToken");
    const resp = (await axios.post(
      `${url}/Acesso/refreshToken?refreshToken=${authRfToken}&token=${authTokenStore}`,
    )) as any;
    if (resp.data.token && resp.data.refreshToken) {
      localStorage.setItem("token", resp.data.token);
      localStorage.setItem("rfToken", resp.data.refreshToken);
      return resp.data.token;
    } else {
      localStorage.clear();
      navigateTo("/login");
      throw new Error("Token or refreshToken not received");
    }
  } catch (error) {
    throw new Error("Error refreshing token:");
  }
};

const getTokenFromLocal = async () => {
  let token = localStorage.getItem("token");
  if (!token) {
    return null;
  }

  try {
    const decodedToken = jwtDecode(token);
    const currentTimestamp = Math.floor(Date.now() / 1000);

    if (decodedToken.exp && decodedToken.exp < currentTimestamp) {
      token = await refreshToken();
      location.reload();
    }

    token = localStorage.getItem("token")?.startsWith("Bearer")
      ? localStorage.getItem("token")
      : `Bearer ${localStorage.getItem("token")}`;

    return token;
  } catch (error) {
    throw new Error("Error getting token: " + error);
  }
};

axiosInstance.interceptors.request.use(async (config) => {
  if (!isFormData(config.data)) {
    config.headers["Content-Type"] = "application/json";
  } else {
    config.headers["Content-Type"] = "multipart/form-data";
  }
  config.headers["TokenWebHook"] =
    "t8pAuR37CSoAaWTT4QBltMqwyd7uh4XhjIjwhhQ9zEqzh1odyfV075UsLAUZEZP2";
  config.headers.Authorization = await getTokenFromLocal();
  return config;
});

export async function read(url: string, Message: any) {
  try {
    const { data } = await axiosInstance.get(url, Message);
    return data;
  } catch (error) {
    console.error("Error in reading", error || "");
  }
}

export async function exclude(url: string) {
  try {
    await axiosInstance.delete(url);
  } catch (error) {
    console.error("error in excludeding", error || "");
  }
}

export async function create(url: string, object: any) {
  try {
    const { data } = await axiosInstance.post(url, object, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return data;
  } catch (error) {
    console.error("Error in creating", error || "");
  }
}

export async function edit(url: string, object: {}) {
  try {
    const { data } = await axiosInstance.put(url, object);
    return data;
  } catch (error) {
    console.error("Error in editeding", error || "");
  }
}
